import { Switch } from '../../cdl/Switch/Switch';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

interface MailSettingsProps {
    mailSettings: {
        newsletter: boolean;
        transactional: boolean;
    };
    onSettingChange: (newMailSettings: MailSettingsProps['mailSettings']) => void;
}

export const MailSettings = ({ mailSettings, onSettingChange }: MailSettingsProps) => {
    return (
        <>
            <Text variant="subtitle2" marginTop={16}>
                {translate('global.mailsettings.title')}
            </Text>

            <Box display="flex" flexDirection="column" gap={16}>
                <Switch
                    label={translate('global.mailsettings.newsletter')}
                    checked={mailSettings.newsletter}
                    onChange={(checked) => onSettingChange({ ...mailSettings, newsletter: checked })}
                />

                <Switch
                    label={translate('global.mailsettings.transactional')}
                    checked={mailSettings.transactional}
                    onChange={(checked) => onSettingChange({ ...mailSettings, transactional: checked })}
                />
            </Box>
        </>
    );
};
